import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3dba3030"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "template-manager"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "account-name"
};
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { getTemplateList, getTemplateListTerm, getTemplateIdByHisType, saveHisTypeTemplateIdContact, delTemplateId } from '@/api/template';
import { ElMessage } from 'element-plus';
export default {
  __name: 'template-manage',
  setup(__props) {
    const route = useRoute();
    const {
      accountId,
      path
    } = route.params;

    // 已配置的模板id列表
    const templateList = ref([]);
    /**
     * 得到这个公众号已配置的模板id列表
     */
    const getTemplateListData = async () => {
      const res = await getTemplateList(accountId);
      templateList.value = res;
    };

    // 需要配置的模板短id列表
    const templateTermList = ref([]);
    /**
     * 得到所有需要配置的模板短id列表
     */
    const getTemplateListTermData = async () => {
      const res = await getTemplateListTerm();
      templateTermList.value = res;
      await getTemplateListData();
      templateTermList.value = templateTermList.value.map(item => {
        if (templateList.value.find(val => val.hisType === item.hisType)) {
          item = {
            ...item,
            ...templateList.value.find(val => val.hisType === item.hisType)
          };
        }
        return item;
      });
    };
    getTemplateListTermData();
    const onConfigurationHandler = async row => {
      if (row.templateId) {
        ElMessage.warning('该链接已配置');
        return;
      }
      const res = await getTemplateIdByHisType(path, row.hisType);
      await saveHisTypeTemplateIdContact({
        id: row.id ? row.id : '',
        accountId: accountId,
        hisType: row.hisType,
        templateId: res.template_id
      });
      await getTemplateListTermData();
      ElMessage.success('配置成功');
    };
    const oneKeyConfigurationHandler = () => {
      const requestArr = templateTermList.value.filter(item => !item.templateId);
      configModule(requestArr, 0);
    };
    const configModule = async (requestArr, index) => {
      if (index >= requestArr.length) {
        await getTemplateListTermData();
        ElMessage.success('配置成功');
        return;
      }
      const res = await getTemplateIdByHisType(path, requestArr[index].hisType);
      await saveHisTypeTemplateIdContact({
        id: requestArr[index].id ? requestArr[index].id : '',
        accountId: accountId,
        hisType: requestArr[index].hisType,
        templateId: res.template_id
      });
      await configModule(requestArr, index + 1);
    };
    const onDelConfigurationHandler = async row => {
      // 删除微信后台模板
      await delTemplateId(path, row.templateId);
      await saveHisTypeTemplateIdContact({
        id: row.id,
        accountId: accountId,
        hisType: row.hisType,
        templateId: ''
      });
      await getTemplateListTermData();
      ElMessage.success('删除关系成功');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "configs-box",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$route.params.accountName), 1), _createVNode(_component_el_button, {
          type: "primary",
          onClick: oneKeyConfigurationHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 一键配置 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: templateTermList.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称"
          }), _createVNode(_component_el_table_column, {
            prop: "hisType",
            label: "短链接"
          }), _createVNode(_component_el_table_column, {
            prop: "templateId",
            label: "长链接",
            width: "450"
          }), _createVNode(_component_el_table_column, {
            prop: "desc",
            label: "描述",
            width: "600"
          }), _createVNode(_component_el_table_column, {
            width: "220"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: $event => onConfigurationHandler(row),
              disabled: !!(row !== null && row !== void 0 && row.templateId)
            }, {
              default: _withCtx(() => [_createTextVNode(" 点击配置 ")]),
              _: 2
            }, 1032, ["onClick", "disabled"]), _createVNode(_component_el_button, {
              type: "danger",
              onClick: $event => onDelConfigurationHandler(row),
              disabled: !!!(row !== null && row !== void 0 && row.templateId)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick", "disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      })]);
    };
  }
};